import { Component, OnInit } from '@angular/core';
import { BaseReportCardComponent } from '../base-report-card.component';
import { Chart } from 'chart.js';
import { ReportGenSvc } from 'src/app/services_autogenerated/generated_services';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Component({
    selector: 'app-work-to-be-completed',
    templateUrl: './work-to-be-completed.component.html',
    styleUrls: ['./work-to-be-completed.component.css'],
    standalone: false
})
export class WorkToBeCompletedComponent extends BaseReportCardComponent implements OnInit {
  workToBeCompleted: any;
  loading: boolean = true;

  constructor(private reportService: ReportGenSvc) { 
    super();
  }

  ngOnInit() {
    this.reportService.getCurrentWorkBacklogs().pipe(
      catchError((error: any) => {
        return throwError(error)})
    ).subscribe(res => {
      this.workToBeCompleted = res;
      this.loading = false;
      this.createPieChart();
    })
  }

  createPieChart(){
    new Chart(document.getElementById("piechart"), {
      type: 'pie',
      data: {
        datasets: [{
          data: this.workToBeCompleted.map(x => x.total),
          backgroundColor: [
            'rgb(154,152,111)',
            'rgb(97,116,86)',
            'rgb(155,119,167)',
            'rgb(169,169,169)',
            'rgb(171,113,112)',
            'rgb(97, 97, 155)'
          ]
        }],

        labels: this.workToBeCompleted.map(x => x.type)
      },
      options: {
      }
    })
  }
}
